import type { OrderInfo, GeoPoint } from '@@partner:types:app'
import type { UpdateOrderInfoMutationVariableData } from '@@partner:graphql/mutation/order/updateOrderInfo.gql'
import type { GQL_ID } from '@@partner:types:graphql'

import { mergeLeft, mergeLeftDropping } from 'merge-left-utils'
import { flatten, unflatten } from 'flattenizer'

export interface OrderFormState {
  id?: GQL_ID
  'recipientInfo.firstName'?: string
  'recipientInfo.lastName'?: string
  shippingSide: string
  assemblingSide: string
  shop_id?: GQL_ID
  payment_type: string
  customerGeoPoint?: GeoPoint
  address_appartments?: string
  address_intercom?: string
  address_porch?: string
  address_floor?: number
  comment?: string
  door_delivery: boolean
  address?: string
  fullAddress?: string
  slot_id?: GQL_ID
}

const DEFAULT_ORDER_STATE: OrderFormState = {
  id: undefined,
  'recipientInfo.firstName': '',
  'recipientInfo.lastName': '',
  shippingSide: 'our',
  assemblingSide: 'our',
  shop_id: undefined,
  payment_type: 'YANDEX',
  customerGeoPoint: {
    latitude: undefined,
    longitude: undefined
  },
  address_appartments: undefined,
  address_intercom: undefined,
  address_porch: undefined,
  address_floor: undefined,
  comment: undefined,
  door_delivery: false,
  address: '',
  fullAddress: undefined,
  slot_id: undefined
}

export const makeDefaultState = (order: OrderInfo) =>
  mergeLeft(DEFAULT_ORDER_STATE, {
    ...(flatten(order) as OrderFormState),
    customerGeoPoint: order.customerGeoPoint,
    address: order.address || ''
  })

export const mapStateToApiVariable = (
  state: OrderFormState
): UpdateOrderInfoMutationVariableData => {
  const structured = unflatten<
    OrderFormState,
    UpdateOrderInfoMutationVariableData
  >(state)

  // drop the ID field from state to be convenient with graphql input type
  if (structured) {
    return mergeLeftDropping([ 'id', 'fullAddress' ], structured, structured)
  }

  return {}
}
